<template>
    <div class="seckill" :style="'padding: 0 ' + item.prConfig.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
        <div class="seckillBox" :style="'background-color: ' + item.bgColor.color[0].item + ';'" :class="{'border-radius' : item.conStyle.type == 1}">
            <div class="hd">
                <div class="left">
                    <img :src="item.imgConfig.url">
                    <span class="titile-name">限时秒杀</span>
                    <div class="time" :style="'color: ' + item.themeColor.color[0].item + ';'">
                        <span>00</span>
                        <em>:</em>
                        <span>00</span>
                        <em>:</em>
                        <span>00</span>
                    </div>
                </div>
                <div class="right">
                    <span>更多</span>
                </div>
            </div>
            <div class="product-detail">
                <div class="product-item" v-for="(seckillTtem,index) in 3" :key="index" :style="'margin-right: ' + item.lrConfig.val + 'px;'">
                    <img src="@/components/decoration/static/not_img_product.png">
                    <div class="discount" :style="'color: ' + item.themeColor.color[0].item + ';border: 1px solid' + item.themeColor.color[0].item + ';'" v-if="item.discountShow.val">
                        <span>1.2折起</span>
                    </div>

                    <div class="product-name" v-if="item.titleShow.val">
                        <span>小米家用电饭煲，选用最好的材料打造</span>
                    </div>

                    <div class="price">
                        <div class="tag" :style="'background-color: ' + item.themeColor.color[0].item + ';'" v-if="item.seckillShow.val">
                            <span>抢</span>
                        </div>
                        <template v-if="item.priceShow.val">
                            <span class="num-label" :style="'color: ' + item.themeColor.color[0].item + ';'">￥</span>
                            <span class="num" :style="'color: ' + item.themeColor.color[0].item + ';'">234</span>
                        </template>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default: {}
        }
    },
    data(){
        return{

        }
    }
}
</script>

<style scoped lang="scss">
.seckillBox{
    width: 100%;
    padding: 15px 10px;
    background-color: #fff;
    overflow: hidden;

    .hd{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left{
            display: flex;
            align-items: center;
            justify-content: left;

            img{
                width: 18px;
                height: 18px;
                margin-right: 5px;
            }

            .titile-name{
                font-size: 16px;
                font-weight: 700;
            }

            .time{
                margin-left: 5px;
                font-size: 12px;

                span{
                    padding: 0 3px;
                    background-color: rgba(252, 60, 62, 0.09);
                }

                em{
                    margin: 0 3px;
                    font-style: normal;
                }
            }
        }

        .right{
            font-size: 12px;
            color: #606266;
        }
    }

    .product-detail{
        width: 100%;
        margin-top: 8px;
        display: flex;
        align-items: center;
        overflow: hidden;

        .product-item{
            position: relative;
            width: 110px;
            flex-shrink: 0;

            img{
                border-radius: 6px;
            }

            .discount{
                position: absolute;
                top: 80px;
                left: 10px;
                padding: 0 3px;
                font-size: 12px;
            }

            .product-name{
                margin-top: 5px;
                padding: 0 3px;
                font-size: 13px;
                line-height: 16px;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                white-space: nowrap;
            }

            .price{
                display: flex;
                align-items: center;
                line-height: 16px;

                .tag{
                    width: 16px;
                    height: 16px;
                    background-color: #e93323;
                    font-size: 12px;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .num-label{
                    margin-top: 5px;
                    font-weight: 700;
                    font-size: 12px;
                }

                .num{
                    font-weight: 700;
                }
            }
        }
    }
}

.border-radius{
    border-radius: 6px;
}
</style>